export const FETCH_WAREHOUSE_KITCHEN_LIST_LOADING =
  'FETCH_WAREHOUSE_KITCHEN_LIST_LOADING';
export const WAREHOUSE_KITCHEN_LIST_DATA = 'WAREHOUSE_KITCHEN_LIST_DATA';
export const FETCH_WAREHOUSE_KITCHEN_LIST_LOADING_ERROR =
  'FETCH_WAREHOUSE_KITCHEN_LIST_LOADING_ERROR';
export const PRINT_WAREHOUSE_KITCHEN_LOAD_REPORTS_LOADING =
  'PRINT_WAREHOUSE_KITCHEN_LOAD_REPORTS_LOADING';
export const PRINT_LOADING_ERROR = 'PRINT_LOADING_ERROR';
export const FETCH_TRUCK_ROUTE_LIST_LOADING = 'FETCH_TRUCK_ROUTE_LIST_LOADING';
export const FETCH_TRUCK_ROUTE_LIST_LOADING_ERROR =
  'FETCH_TRUCK_ROUTE_LIST_LOADING_ERROR';
export const TRUCK_ROUTE_LIST_DATA = 'TRUCK_ROUTE_LIST_DATA';
export const CLEAR_PRINT_LOADING_ERROR = 'CLEAR_PRINT_LOADING_ERROR';



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousepicklist/state/types.js